import { parseJwt } from '../funcs';

export function isUserASuperAdmin(accessToken: string) {
  if (!accessToken) {
    return false;
  }

  const jwtPayload = parseJwt(accessToken);

  return jwtPayload?.isu ?? false;
}

export function isGuidebookOnlyUser(accessToken: string) {
  const jwtPayload = parseJwt(accessToken);
  return jwtPayload?.userType === 'GUIDEBOOK_USER';
}
